import React from 'react';
import '../css/ui/GridLines.scss';

export default class GridLines extends React.Component<{className?:string}>
{
	render()
	{
		let className = (this.props.className)?this.props.className:'gridLines';
		return (null);
		return (
			<div className={className}>
				<div className='line'></div>
				<div className='line'></div>
				<div className='line'></div>
				<div className='line'></div>
				<div className='line'></div>
			</div>
		)
	}
}
